import BrandTrack from './BrandTrack'
import styles from './BrandsHeader.module.scss'

export default function BrandsHeader({
  title = (
    <>
      Premium brands
      <br />
      Premium experience
    </>
  ),
  brands,
}) {
  return (
    <header className={styles.header}>
      <div className={styles.trackWrapper}>
        <BrandTrack brands={brands} rows={4} />
      </div>
      <div className={styles.headingContainer}>
        <div>
          <h1 className="h1 match">{title}</h1>
        </div>
      </div>
    </header>
  )
}
